<template>
  <div>
    <div class="ui four column center aligned grid" style="margin-bottom: 10px;">
      <div 
        class="column" 
        v-for="(image, imageIndex) in currentImages" 
        :key="imageIndex"
        @click="index = imageIndex"
      >
        <img 
          :src="image.picture.url" 
          class="ui image" 
          style="height: 250px; object-fit: contain; margin-right: 8px; cursor: pointer"
        />
      </div>
      <div class="column">
        <imageComponent 
          :object="imageObject"
          :sendingURL="'reservation_visits/' + reservationVisitId + '/add/image'"
          :imageCallBack="imageCallBack"
          v-if="canAdd"
        />
      </div>
    </div>
    <vue-gallery-slideshow :images="images()" :index="index" @close="index = null"></vue-gallery-slideshow>
  </div>
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow';
export default {
  components: {
    imageComponent: require('@/components/abstract_components/Image').default,
    VueGallerySlideshow
  },
  props: {
    reservationVisitId: { type: Number, required: true },
    album: { type: Object, required: true },
    albumCallBack: { type: Function, required: true},
    canAdd: { type: Boolean, default: false},
  },
  watch: {
    album: {
      handler: function () {
        this.currentImages = this.album && this.album.images ? 
          window._.cloneDeep(this.album.images) : []
      },
      deep: true
    }
  },
  mounted () {
    this.currentImages = this.album && this.album.images ? 
        window._.cloneDeep(this.album.images) : []
  },
  data () {
    return {
      currentImages: [],
      imageObject: this.getImageObject(),
      index: null
    }
  },
  methods: {
    imageCallBack(album) {
      this.currentImages = album.images
      this.imageObject = this.getImageObject()
      this. albumCallBack(album)
    },
    getImageObject() {
      return {
        album: {
          images: []
        }
      }
    },
    images() {
      return this.currentImages.length ?
        this.currentImages.map(image => image.picture.url) : []
    }
  }
}
</script>

<style scoped>
  .image-size {
    height: 50px !important;
    object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/ImagesPart.vue